import { render, staticRenderFns } from "./FeatureCompetitiveRelate.vue?vue&type=template&id=47ba4b82"
import script from "./FeatureCompetitiveRelate.vue?vue&type=script&lang=js"
export * from "./FeatureCompetitiveRelate.vue?vue&type=script&lang=js"
import style0 from "./FeatureCompetitiveRelate.vue?vue&type=style&index=0&id=47ba4b82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports